import React from 'react';
import TitleComponent from '../../../../components/base/TitleComponent';
import { LoadingLines } from '../../../../components/ui/modals/SearchModal/LoadingList';
import NoData from '../../../../components/base/NoData';
import uniqueId from '../../../../utils/uniqueId';
import styles from './TopBlocks.module.scss';
import LogoDisplay from '../../../../components/ui/modals/SearchModal/LogoDisplay';
import WalletIcon from '../../../../components/base/WalletIcon';
import TruncatedText from '../../../../components/base/TruncatedText';
import { getWalletLabel } from '../../../../utils/walletIcons';

const TopBlocks = ({ title, info = null, data, isLoading }) => {
  const languageNamesInEnglish = new Intl.DisplayNames(['en'], {
    type: 'language',
  });
  const regionNamesInEnglish = new Intl.DisplayNames(['en'], {
    type: 'region',
  });

  return (
    <div className={styles.wrapper}>
      <TitleComponent info={info}>{title}</TitleComponent>
      <div className="d-flex flex-column w-100 pt-3">
        {isLoading ? (
          <LoadingLines rows={1} />
        ) : data && data.length ? (
          data
            .filter((elem) => elem.value)
            .map((elem) => (
              <div
                className="d-flex justify-content-between w-100 my-2 align-items-center"
                key={uniqueId('top_elem')}
              >
                <div className="d-flex align-items-center gap-2 w-50">
                  {title === 'Top Countries' ? (
                    <LogoDisplay
                      logo={`/trackedWebsite/countryFlags/${elem.value.toLowerCase()}.svg`}
                      size="21px"
                      asset="address"
                      position="static"
                    />
                  ) : title === 'Top Wallets' ? (
                    <WalletIcon wallet={elem.value} rounded />
                  ) : title === 'Top Environments' ? (
                    <LogoDisplay
                      logo={
                        elem.value.toLowerCase() === 'evm'
                          ? `/trackedWebsite/chainLogo/ethereum.svg`
                          : `/trackedWebsite/chainLogo/${elem.value.toLowerCase()}.svg`
                      }
                      size="21px"
                      asset="address"
                      position="static"
                      rounded={false}
                    />
                  ) : null}
                  <TruncatedText
                    className={`${styles.spanField}`}
                    text={
                      title === 'Top Languages'
                        ? languageNamesInEnglish.of(elem.value)
                        : title === 'Top Countries'
                          ? regionNamesInEnglish.of(elem.value)
                          : title === 'Top Wallets'
                            ? getWalletLabel(elem.value)
                            : elem.value
                    }
                  />
                </div>
                <span className={`${styles.spanValue} text-truncate`}>
                  {`${elem.visitor_count.toLocaleString()} visitor${elem.visitor_count !== 1 ? 's' : ''}`}
                </span>
              </div>
            ))
        ) : (
          <NoData />
        )}
      </div>
    </div>
  );
};

export default TopBlocks;
